import { createAsyncThunk, createSlice, nanoid } from "@reduxjs/toolkit";
import { GetMyPosition } from "../../services/PositionService";

const initialState = {
  positions: { lastName: "بدون سمت", firstName: "", id: "" },
  status: "idle",
  selectedPosition: "",
  error: "" as string | undefined,
};

export const fetchUserPosition = createAsyncThunk(
  "/position/fetchUserPosition",
  async () => {
    const response = await GetMyPosition();
    return response.data;
  }
);

const positionSlice = createSlice({
  name: "position",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPosition.pending, (state, action) => {
        //		console.log("pen");
        state.status = "loading";
      })
      .addCase(fetchUserPosition.fulfilled, (state, action) => {
        //	console.log("ful");

        state.positions = action.payload;
        state.status = "idle";
        state.selectedPosition = "";
      })
      .addCase(fetchUserPosition.rejected, (state, action) => {
        //console.log("rej");
        state.positions = { lastName: "بدون سمت", firstName: "", id: "" };
        //console.log(state.positions);

        state.error = action.error.message;
        state.status = "idle";
      });
  },
});

export const getMyPosition = (state: any) => state.positions;

export default positionSlice.reducer;
